var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.agencyId)?_c('AgencyContactDetailsComponent',{attrs:{"id":_vm.agencyId}}):_c('p',{staticClass:"m-0"},[_vm._v("Onbekend")])}
var staticRenderFns = []

export { render, staticRenderFns }